import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Est-ce que le prix peut changer après le devis ?",
    a: "Non. Le prix est fixé définitivement après acceptation du devis et garanti. Aucune mauvaise surprise sur place, jamais.",
  },
  {
    q: "Où se déroule le montage ?",
    a: "À mon atelier à Meudon (92), proche de Paris. Pour le service clé en main, la livraison à domicile est incluse en Île-de-France. Je propose aussi un service d'intervention à domicile pour montage, nettoyage ou upgrade sur place.",
  },
  {
    q: "Quels types de PC montez-vous ?",
    a: "Gaming (1080p / 1440p / 4K), streaming, bureautique haute performance, stations de travail créatives (montage vidéo, 3D, IA).",
  },
  {
    q: "Combien de temps prend un montage ?",
    a: "En général entre 24 et 72h selon la configuration et la disponibilité des composants. Les délais sont communiqués dans le devis.",
  },
  {
    q: "Garantie sur les composants ?",
    a: "Les composants sourcés par mes soins sont neufs et conservent leur garantie constructeur (1 à 3 ans selon la marque).",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="reveal">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
            // FAQ
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Les questions qu'on me pose souvent.
          </h2>
        </div>

        <div className="mt-12 reveal">
          <Accordion
            type="single"
            collapsible
            data-testid="faq-accordion"
            className="w-full"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="text-left text-base sm:text-lg font-display font-semibold hover:text-violet-300 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-zinc-400 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
